import ContentSourceForm from '@/components/tenant-settings/content-source-form/content-source-form';
import DefaultGroups from '@/components/tenant-settings/default-groups/default-groups';
import DefaultRosterGrades from '@/components/tenant-settings/default-roster-grades/default-roster-grades';
import DefaultRosterSubject from '@/components/tenant-settings/default-roster-subject/default-roster-subject';
import EnableMilestoreFW from '@/components/tenant-settings/enable-milestore-fw/enable-milestore-fw';
import MinScoreCompletionForm from '@/components/tenant-settings/min-score-completion-form/min-score-completion-form';
import MinStartingDiagnostic from '@/components/tenant-settings/min-starting-diagnostic/min-starting-diagnostic';
import NavRouteMapView from '@/components/tenant-settings/nav-route-map-view/nav-route-map-view';
import NavigatorClassSetting from '@/components/tenant-settings/navigator-class-setting/navigator-class-setting';
import RosterSubjectKeywords from '@/components/tenant-settings/roster-subject-keywords/roster-subject-keywords';
import WorkingDays from '@/components/tenant-settings/working-days/working-days';
import MasteryCompetencyCompletionSetting from '@/routers/views/setup/settings/white-labeling/white-labeling-settings/mastry-competency-completion-setting/mastery-competency-completion-setting';
import OnOffCheckbox from './on-off-checkbox/on-off-checkbox';
import PrefFacetSubject from './pref-facet-subject/pref-facet-subject';
import TxFwPreference from './tx-fw-preference/tx-fw-preference';
import TxSubClassifierPrefs from './tx-sub-classifier-prefs/tx-sub-classifier-prefs';
import TxSubjectPreference from './tx-subject-preference/tx-subject-preference';
import OtherLibraryIds from '@/components/tenant-settings/other-library-ids/other-library-ids';
import CustomNotifications from './custom-notifications/custom-notifications';
import LibraryVisibility from './library-visibility/library-visibility';
import DefaultViewSnsFwLevel from './default-view-sns-fw-level/default-view-sns-fw-level';
import SignatureContentsPublishers from './signature-contents-publishers/signature-contents-publishers';
import UploadImage from './upload-image/upload-image';
import InputNumber from './input-number/input-number';
import MasteryContentCompletion from './mastery-content-completion/mastery-content-completion';
import CatSubFwAarray from './cat-sub-fw-array/cat-sub-fw-array';

export default {
    'default-groups': DefaultGroups,
    'navigator-class-setting': NavigatorClassSetting,
    'default-roster-subject': DefaultRosterSubject,
    'default-roster-grades': DefaultRosterGrades,
    'roster-subject-keywords': RosterSubjectKeywords,
    'completion-score': MinScoreCompletionForm,
    'mastery-content-completion-setting': MasteryContentCompletion,
    'min-starting-diagnostic': MinStartingDiagnostic,
    'working-days': WorkingDays,
    'nav-route-map-view': NavRouteMapView,
    'other-library-ids': OtherLibraryIds,
    'enable-milestore-fw': EnableMilestoreFW,
    'content-source': ContentSourceForm,
    'on-off-checkbox': OnOffCheckbox,
    'pref-facet-subject': PrefFacetSubject,
    'tx-fw-preference': TxFwPreference,
    'tx-sub-classifier-prefs': TxSubClassifierPrefs,
    'tx-subject-preference': TxSubjectPreference,
    'custom-notifications': CustomNotifications,
    'library-visibility': LibraryVisibility,
    'default-view-sns-fw-level': DefaultViewSnsFwLevel,
    'signature-contents-publishers': SignatureContentsPublishers,
    'upload-image': UploadImage,
    'input-number': InputNumber,
    'enable_marker': CatSubFwAarray,
};
